
let attempts = 0;
const interval = setInterval(function () {
  const allReviewsText = document.querySelectorAll('.jdgm-prev-badge__text');
  if(allReviewsText.length > 0 ){
    allReviewsText.forEach(function (selector) {
        const currenthtml = selector.innerHTML;
        const part_1 =  currenthtml.split('(')[0];
        const part_2 =  currenthtml.split('(')[1];
        const checkmark = `<span class="image_checkmark" style="display: inline-block; margin-bottom: -4px;"><img width="20px" src="https://cdn.shopify.com/s/files/1/0789/9217/9492/files/Mediamodifier-Design.svg?v=1745846466" alt="Badge Image"></span>`;
        const innerHTml = part_2 ? `${part_1} ${checkmark} (${part_2}`:`${part_1.trim()} ${checkmark}`;
        selector.innerHTML = innerHTml;
    });
   clearInterval(interval); 
  }
  attempts++;
  console.log(attempts)
  if(attempts>10){
    clearInterval(interval); 
  }
}, 1000);


['change'].forEach(eventType => {
  document.addEventListener(eventType, function(event) {
    if (event.target.classList.contains('price-range__input') ||event.target.classList.contains('tag__input')) {
        let attempts = 0;

      const interval = setInterval(function () {
        const allReviewsText = document.querySelectorAll('.jdgm-prev-badge__text');
        if (allReviewsText.length > 0) {
          allReviewsText.forEach(function (selector) {
            const currenthtml = selector.innerHTML;
            const [part_1, part_2] = currenthtml.split('(');
            const checkmark = `<span class="image_checkmark" style="display: inline-block; margin-bottom: -4px;"><img width="20px" src="https://cdn.shopify.com/s/files/1/0789/9217/9492/files/Mediamodifier-Design.svg?v=1745846466" alt="Badge Image"></span>`;
            const innerHTML = part_2 ? `${part_1.trim()} ${checkmark} (${part_2}`: `${part_1.trim()} ${checkmark}`;
            selector.innerHTML = innerHTML;
          });
          clearInterval(interval);
        }
        attempts++;
        if(attempts>10){
          clearInterval(interval); 
        }
      }, 1000);
    }
  });
});

(function () {
  const selectors = {
    section: '[data-section-type="collection-grid"]',
    tagLink: '[data-sticky-tag-link]',
    grid: '[data-sticky-products-grid]',
    pagination: '[data-sticky-pagination]',
    paginationLink: '[data-sticky-pagination] a[href]',
    // Sort radios in the filter drawer (collection-tabs-drawer-groups).
    sort: '[data-collection-sort] input[type="radio"]',
    rail: '[data-sticky-category-rail]',
    category: '[data-sticky-category]'
  };

  let isLoadingStickyTag = false;

  function bindStickyTagLinks() {
    document.querySelectorAll(selectors.tagLink).forEach(function (link) {
      if (link.dataset.stickyTagBound === 'true') return;
      link.dataset.stickyTagBound = 'true';
      link.addEventListener('click', onStickyTagClick);
    });
  }

  function onStickyTagClick(event) {
    const link = event.currentTarget;
    event.preventDefault();
    if (isLoadingStickyTag) return;
    showStickyCategories(link);
    loadStickyTagCollection(link, true);
  }

  // Category rail: each category picks its sticky tag entry, and both sides
  // carry that entry's handle (main-collection-sticky-tags,
  // collection-sticky-tags). Only the active tag's categories show, and the
  // first one opens, as the bundle builder does.
  function showStickyCategories(link) {
    const rail = document.querySelector(selectors.rail);
    if (!rail) return;

    let first = null;
    rail.querySelectorAll(selectors.category).forEach(function (item) {
      const mine = item.dataset.stickyCategoryTag === link.dataset.stickyTagKey;
      item.hidden = !mine;
      if (mine && !first) first = item;
    });
    rail.hidden = !first;
    setStickyCategory(first);
  }

  function setStickyCategory(current) {
    document.querySelectorAll(selectors.category).forEach(function (item) {
      const isActive = item === current;
      item.classList.toggle('is-active', isActive);
      if (isActive) item.setAttribute('aria-current', 'true');
      else item.removeAttribute('aria-current');
    });
  }

  // What the grid is showing: the active category, else the tag's own collection.
  function currentStickyUrl(link) {
    const category = document.querySelector(`${selectors.category}.is-active`);
    const href = category ? category.getAttribute('href') : link.dataset.stickyTagUrl || link.getAttribute('href');
    return new URL(href, window.location.origin);
  }

  function onStickyCategoryClick(event) {
    const item = event.target.closest(selectors.category);
    if (!item || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const activeLink = document.querySelector(`${selectors.tagLink}.is-active`);
    if (!activeLink) return;

    event.preventDefault();
    if (isLoadingStickyTag || item.classList.contains('is-active')) return;

    setStickyCategory(item);

    // A switch made deep in one category would land deep in the next. Once the
    // rail is pinned, the catalog's top has scrolled above it: bring the
    // catalog back to that line (its scroll-margin-top in collection-tabs.css).
    const rail = item.closest(selectors.rail);
    const catalog = rail && rail.parentElement;
    if (catalog && catalog.getBoundingClientRect().top < rail.getBoundingClientRect().top - 1) {
      catalog.scrollIntoView({ block: 'start' });
    }

    loadStickyTagUrl(activeLink, currentStickyUrl(activeLink), false);
  }

  function onStickyTagSortChange(event) {
    if (!event.target.matches(selectors.sort)) return;

    const activeLink = document.querySelector(`${selectors.tagLink}.is-active`);

    // No sticky tags on this collection: sort the page itself, as New Arrivals does.
    if (!activeLink) {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    loadStickyTagCollection(activeLink, false);
  }

  function loadStickyTagCollection(link, updateActiveTag) {
    loadStickyTagUrl(link, currentStickyUrl(link), updateActiveTag);
  }

  function onStickyPaginationClick(event) {
    const paginationLink = event.target.closest(selectors.paginationLink);

    if (!paginationLink) return;

    const activeLink = document.querySelector(`${selectors.tagLink}.is-active`);

    if (!activeLink) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const activeUrl = currentStickyUrl(activeLink);
    const paginationUrl = new URL(paginationLink.href, window.location.origin);

    paginationUrl.searchParams.forEach(function (value, key) {
      activeUrl.searchParams.set(key, value);
    });

    loadStickyTagUrl(activeLink, activeUrl, false);
  }

  function loadStickyTagUrl(link, url, updateActiveTag) {
    const section = link.closest(selectors.section);
    const currentGrid = document.querySelector(selectors.grid);

    if (!section || !currentGrid || isLoadingStickyTag) return;

    isLoadingStickyTag = true;

    const currentPagination = document.querySelector(selectors.pagination);
    const collectionWrapper = document.querySelector('.collection-grid__wrapper');
    const sectionId = section.getAttribute('data-section-id');
    const sortInput = document.querySelector(`${selectors.sort}:checked`);

    url.searchParams.set('section_id', sectionId);

    if (sortInput) {
      url.searchParams.set('sort_by', sortInput.value);
    }

    if (updateActiveTag) {
      // btn--tertiary-active is the filled pill of the New Arrivals tabs.
      document.querySelectorAll(selectors.tagLink).forEach(function (tagLink) {
        tagLink.classList.remove('is-active', 'btn--tertiary-active');
        tagLink.removeAttribute('aria-current');
      });

      link.classList.add('is-active', 'btn--tertiary-active');
      link.setAttribute('aria-current', 'page');
    }

    if (collectionWrapper) {
      collectionWrapper.classList.add('unload');
    }

    fetch(url.toString())
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        const newDoc = new DOMParser().parseFromString(html, 'text/html');
        const newGrid = newDoc.querySelector(selectors.grid);
        const newPagination = newDoc.querySelector(selectors.pagination);

        if (newGrid) {
          currentGrid.innerHTML = newGrid.innerHTML;
        }

        if (currentPagination) {
          currentPagination.innerHTML = newPagination ? newPagination.innerHTML : '';
        }

        if (window.theme && typeof theme.reinitProductGridItem === 'function') {
          theme.reinitProductGridItem();
        }

        document.dispatchEvent(new CustomEvent('collection:reloaded'));
      })
      .catch(function () {
        if (updateActiveTag) {
          link.classList.remove('is-active', 'btn--tertiary-active');
          link.removeAttribute('aria-current');
        }
      })
      .finally(function () {
        if (collectionWrapper) {
          collectionWrapper.classList.remove('unload');
        }

        isLoadingStickyTag = false;
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindStickyTagLinks);
  } else {
    bindStickyTagLinks();
  }

  document.addEventListener('page:loaded', bindStickyTagLinks);
  document.addEventListener('collection:reloaded', bindStickyTagLinks);
  document.addEventListener('change', onStickyTagSortChange, true);
  document.addEventListener('click', onStickyPaginationClick, true);
  document.addEventListener('click', onStickyCategoryClick);
})();
